<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/unidades">Unidades</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes da Unidade</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Unidade
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome da Unidade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="unidade.nome_unidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Vínculo</label>
                <v-select
                  label="nome_empresa"
                  class="form-select"
                  v-model="unidade.empresas_id"
                  :reduce="empresas => empresas.id"
                  :options="empresas"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['#####-###']"
                  v-model="unidade.CEP"
                />
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  class="form-control"
                  v-model="unidade.logradouro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="unidade.bairro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  v-model="unidade.numero"
                  type="number"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p class="pull-right">
                <button href="#0" class="btn_1 medium" @click="editaInformacoes()">Salvar</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      id_unidade: this.$route.params.id_unidade,
      unidade: {},
      empresas: [],
      search: "",
			isLoading: false
    };
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    axios.all([
      axios.get('empresas'),
      axios.get(`unidades/${self.id_unidade}`)
    ])
      .then(axios.spread((resEmpresas, resUnidade) => {
        self.empresas = resEmpresas.data;
        self.unidade = resUnidade.data
        self.isLoading = false;

      }, err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      }))
  },
  methods: {
    editaInformacoes() {
      let self = this;
      self.isLoading = true;

      let objRequest = {
        nome_unidade: self.unidade.nome_unidade,
        CEP: self.unidade.CEP,
        logradouro: self.unidade.logradouro,
        bairro: self.unidade.bairro,
        numero: self.unidade.numero,
        empresas_id: self.unidade.empresas_id
      }

      ajax("put", "unidades/" + self.unidade.id, objRequest)
        .then(() => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Informações foram atualizadas com sucesso!"
          );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error);
        });
		}
  }
};
</script>

<style>

.img {
  display: flex;
  align-items: center;
}

</style>
